import { IStudyChild } from '../entity';
import { schema } from 'normalizr';
import { ScreeningDecision } from '@core/services/api-client.generated';

export interface IScreening extends IStudyChild {
  studyId: string;
  screenerId: string;
  projectId: string;
  screeningDecision: ScreeningDecision;
  stageId: string;
}

export const screeningSchema = new schema.Entity('screenings');
